<template>
    <div>
        <card-header title="Edit WIAA ID" :subheader="user.first_name + ' ' + user.last_name" icon="fa-id-badge"/>

        <card-body>
            <card-list>
                <subheader-list-item title="WIAA Membership ID" icon="fa-id-badge"/>
            </card-list>

            <container-list-item padded v-if="loading" class="has-text-grey is-size-7">
                <i class="fas fa-spinner fa-spin fa-fw mr-2 ml-2"></i>Loading user information...
            </container-list-item>

            <card-list v-if="!loading">
                <data-row title="WIAA ID">
                        <span v-if="user.certification_number">{{user.certification_number}}</span>
                        <span v-else class="has-text-grey">Not Set</span>
                    </data-row>
                <container-list-item padded>


                    <div class="mt-4">
                        <b-field label="New WIAA Membership ID" label-position="inside">
                            <b-input 
                                v-model="newWiaaId" 
                                placeholder="e.g., WA-0000-0000"
                                maxlength="12"
                            />
                        </b-field>
                        <p class="help">Format: WA-####-#### (e.g., WA-1234-5678)</p>
                    </div>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button
                type="is-primary"
                size="is-small"
                @click="saveWiaaId"
                :disabled="!newWiaaId"
            ><i class="fas fa-check mr-2"></i>Save WIAA ID
            </b-button>
            
            <b-button
                size="is-small"
                @click="$closeCard(card)"
                class="ml-2"
            ><i class="fas fa-times mr-2"></i>Cancel
            </b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import DataRow from "@/TIER/components/DataRow";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import {client as http} from '@/http_client';

    export default {
        components: {
            ContainerListItem,
            SubheaderListItem,
            CardList,
            DataRow,
            CardBody,
            CardHeader,
            CardFooter
        },
        props: ['card', 'props', 'child'],
        data() {
            return {
                user: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    certification_number: '',
                    id: ''
                },
                newWiaaId: '',
                loading: true
            };
        },
        methods: {
            loadUser: function () {
                this.$emit('loading', true);
                this.loading = true;
                
                http.get(`wiaa/user/${this.props.userId}/certifications`).then(response => {
                    if (response.data && response.data.user) {
                        this.user = response.data.user;
                        this.newWiaaId = response.data.user.certification_number || '';
                    }
                    this.loading = false;
                    this.$emit('loading', false);
                }).catch(err => {
                    console.error('Error loading user:', err);
                    this.loading = false;
                    this.$emit('loading', false);
                    this.$buefy.toast.open({
                        message: 'Error loading user information',
                        type: 'is-danger',
                        duration: 3000
                    });
                });
            },
            saveWiaaId: function () {
                if (!this.newWiaaId) {
                    this.$buefy.toast.open({
                        message: 'Please enter a WIAA ID',
                        type: 'is-warning',
                        duration: 3000
                    });
                    return;
                }

                this.$emit('loading', true);
                
                const payload = {
                    certification_id: 2,
                    integration_id: 2,
                    certification_number: this.newWiaaId
                };

                http.put(`wiaa/user/${this.props.userId}/certification`, payload).then(() => {
                    this.$emit('loading', false);
                    this.$buefy.toast.open({
                        message: 'WIAA ID updated successfully',
                        type: 'is-success',
                        duration: 3000
                    });
                    
                    // Reload the WIAA certification details card
                    this.$reloadCard('wiaa-certification-details', {userId: this.props.userId});
                    
                    // Reload the WIAA certification search card if it exists
                    this.$reloadCard('wiaa-certification-search');
                    
                    this.$closeCard(this.card);
                }).catch(err => {
                    this.$emit('loading', false);
                    console.error('Error saving WIAA ID:', err);
                    this.$buefy.toast.open({
                        message: 'Error updating WIAA ID',
                        type: 'is-danger',
                        duration: 3000
                    });
                });
            },
            reload: function() {
                this.loadUser();
            }
        },
        watch: {
            'props': function (n, o) {
                if (n.userId !== o.userId) this.loadUser();
            }
        },
        mounted: function () {
            this.loadUser();
        }
    };
</script>

<style lang="scss" scoped>

</style>